import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { NumericFormat } from 'react-number-format'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import {
  copiarCampoGrid,
  eliminarFilaGrid,
  resetModal,
  setModal
} from 'slices/modalSlice'
import GenericSelect from '../reutilizables/genericSelect/GenericSelect'
import { GenericModal } from '../reutilizables/modal/GenericModal'
import * as listaEnviosService from '../servicios/listaEnvioService'
import * as publicacionesService from '../servicios/publicacionesService'
import Checkbox from './Checkbox'

const ENVIO_A_CARGO_COMPRADOR = 3
const GARANTIA_4 = 4

const camposDefault = {
  isFullWidth: false,
  isEditable: true,
  isGrid: true,
  copy: false
}

const campos = [
  {
    type: 'text',
    name: 'nombreLista',
    placeholder: 'Ingrese el nombre la lista',
    label: 'Nombre de la lista',
    isFullWidth: true,
    isEditable: false,
    isGrid: false
  },
  {
    type: 'date',
    name: 'vigenciaDesde',
    label: 'Comienzo de la vigencia',
    isFullWidth: false,
    isEditable: false,
    isGrid: false
  },
  {
    type: 'date',
    name: 'vigenciaHasta',
    label: 'Fin de la vigencia',
    isFullWidth: false,
    isEditable: true,
    isGrid: false
  },
  {
    type: 'text',
    name: 'zona',
    placeholder: 'Zona del envio',
    label: 'Zona',
    ...camposDefault
  },
  {
    type: 'number',
    name: 'cantidadDesde',
    label: 'Cantidad desde',
    ...camposDefault
  },
  {
    type: 'number',
    name: 'cantidadHasta',
    label: 'Cantidad hasta',
    ...camposDefault
  },
  {
    type: 'number',
    name: 'costo',
    label: 'Costo',
    ...camposDefault
  },
  {
    type: 'number',
    name: 'tEstimado',
    label: 'Dias entrega',
    ...camposDefault
  },
  {
    type: 'select',
    name: 'moneda',
    placeholder: 'Seleccione una',
    label: 'Moneda',
    options: [
      { value: 'ARS', label: 'ARS ($)', key: 1 },
      { value: 'USD', label: 'USD (U$S)', key: 2 },
      { value: 'EUR', label: 'EUR (€)', key: 3 }
    ],
    ...camposDefault,
    copy: true
  }
]

const VentasEspeciales = ({
  values,
  onChange,
  onAddGarantia,
  vieneDeAdministrar,
  errorMediosEnvios,
  errorMediosPagos,
  idPublicacion
}) => {
  const [mediosPagos, setMediosPago] = useState([])
  const [mediosEnvios, setMediosEnvio] = useState([])
  const [garantias, setGarantias] = useState([])
  const [enviosUsuario, setEnviosUsuario] = useState([])
  const [medioEnvio, setMedioEnvio] = useState({ idLista: '', nombreLista: '' })
  const [mediosEnviosSeleccionados, setMediosEnviosSeleccionados] = useState(
    values.mediosEnvios || []
  )
  const [actualizar, setActualizar] = useState(false)

  const dispatch = useDispatch()
  const { values: modalValues, errores } = useSelector((state) => state.genericModal)

  useEffect(() => {
    if (values.mediosEnvios) {
      setMediosEnviosSeleccionados(values.mediosEnvios)
    }
  }, [values.mediosEnvios])

  useEffect(() => {
    if (vieneDeAdministrar && values.idListaEnvio) {
      setMedioEnvio({
        idLista: values.idListaEnvio,
        nombreLista: values.nombreListaEnvio || ''
      })
    }
  }, [vieneDeAdministrar, values.idListaEnvio, values.nombreListaEnvio])

  const abrirModalLista = () => {
    dispatch(
      setModal({
        size: 'lg',
        title: 'Crear lista',
        type: 'form',
        body: '',
        show: true,
        editMode: false,
        campos
      })
    )
  }

  useEffect(() => {
    const obtenerDatos = async () => {
      const mediosPagoRtn = await publicacionesService.buscarMedioPago()
      setMediosPago(mediosPagoRtn.data)
      const mediosEnvioRtn = await publicacionesService.buscarMedioEnvio()
      setMediosEnvio(mediosEnvioRtn.data)
      const garantiasRtn = await publicacionesService.buscarGarantia()
      setGarantias(
        garantiasRtn.data.filter((garantia) => garantia.idGarantia !== GARANTIA_4)
      )
    }

    obtenerDatos()
  }, [values])

  const traerInfo = async () => {
    try {
      const idVendedor = vieneDeAdministrar
        ? parseInt(localStorage.getItem('idUsuario'))
        : modalValues.idVendedor

      const { data } = await listaEnviosService.buscarListaPorVendedor(idVendedor)

      const unificadas = Object.values(
        data.reduce((acc, item) => {
          const key = item.nombreLista.trim().toLowerCase()
          if (!acc[key]) {
            acc[key] = {
              idLista: item.idLista,
              nombreLista: item.nombreLista,
              vigenciaDesde: item.vigenciaDesde,
              vigenciaHasta: item.vigenciaHasta,
              idVendedor: item.idVendedor,
              grilla: []
            }
          }

          if (Array.isArray(item.grilla)) {
            acc[key].grilla.push(...item.grilla)
          }

          return acc
        }, {})
      )
      setEnviosUsuario(unificadas)

      if (vieneDeAdministrar && idPublicacion) {
        const { data: listaPublicacion } =
          await listaEnviosService.buscarListaPorVendedor(idVendedor, idPublicacion)
        if (listaPublicacion && listaPublicacion.length > 0) {
          const listaAsociada = listaPublicacion[0]
          setMedioEnvio({
            idLista: String(listaAsociada.idLista),
            nombreLista: listaAsociada.nombreLista
          })
        }
      }
    } catch {
      toast.error('Ocurrió un error al cargar las listas.')
    }
  }

  useEffect(() => {
    traerInfo()
  }, [modalValues.idVendedor, actualizar, vieneDeAdministrar, idPublicacion])

  const onHandleCheckbox = (e, pkId) => {
    let pkName
    let arrSeleccion = values[e.target.name] || []
    let arrCompleto

    switch (e.target.name) {
      case 'mediosPagos':
        arrCompleto = mediosPagos
        pkName = 'idMedioPago'
        break
      case 'mediosEnvios':
        arrCompleto = mediosEnvios
        pkName = 'idMedioEnvio'
        break
      default:
        arrCompleto = garantias
        pkName = 'idGarantia'
    }

    if (e.target.checked) {
      arrSeleccion = [...arrSeleccion, arrCompleto.filter((m) => m[pkName] === pkId)[0]]
    } else {
      arrSeleccion = arrSeleccion.filter((g) => g[pkName] !== pkId)
    }
    onChange(e, 'calc', arrSeleccion)
  }

  const handleChange = (e) => {
    onAddGarantia(e.target.name, parseInt(e.target.value))
  }

  const handleChangeModal = (e) => {
    const { name, value, filaIndex = '' } = e.target
    const campo = filaIndex !== '' ? `${name}_${filaIndex}` : name
    const nuevasValidaciones = { ...errores }

    if (filaIndex === '') {
      dispatch(setModal({ values: { ...modalValues, [name]: value } }))
    } else {
      const copia = [...modalValues.grilla]
      copia[filaIndex] = { ...copia[filaIndex], [name]: value }
      dispatch(setModal({ values: { grilla: copia } }))
    }

    if (errores[campo]) {
      delete nuevasValidaciones[campo]
    }
    dispatch(setModal({ errores: nuevasValidaciones }))
  }

  const onHandleCheckboxMediosEnvios = (e, pkId) => {
    const nuevo = e.target.checked
      ? [...mediosEnviosSeleccionados, mediosEnvios.find((m) => m.idMedioEnvio === pkId)]
      : mediosEnviosSeleccionados.filter((m) => m.idMedioEnvio !== pkId)
    setMediosEnviosSeleccionados(nuevo)
    onChange(e, 'calc', nuevo)
  }

  const handleSeleccionListaEnvio = (name, value) => {
    setMedioEnvio((prevState) => ({
      ...prevState,
      idLista: String(value)
    }))
    const seleccionado = enviosUsuario.find((e) => String(e.idLista) === String(value))
    const nombreLista = seleccionado ? seleccionado.nombreLista : ''

    if (onChange) {
      onChange({ currentTarget: { name: 'idListaEnvio', value: String(value) } })
      onChange({ currentTarget: { name: 'nombreListaEnvio', value: nombreLista } })
    }
  }

  const agregarFila = () => {
    const nuevaFila = {
      zona: '',
      cantidadDesde: 0,
      cantidadHasta: 0,
      costo: 0,
      moneda: '',
      tEstimado: 0
    }

    dispatch(
      setModal({
        values: {
          grilla: [...(modalValues.grilla || []), nuevaFila]
        }
      })
    )
  }

  const handleConfirmarAgregado = async () => {
    const nuevaLista = {
      nombreLista: modalValues.nombreLista,
      vigenciaDesde: modalValues.vigenciaDesde,
      vigenciaHasta: modalValues.vigenciaHasta,
      idVendedor: modalValues.idVendedor,
      grilla:
        modalValues.grilla?.map((fila) => ({
          zona: fila.zona,
          cantidadDesde: fila.cantidadDesde,
          cantidadHasta: fila.cantidadHasta,
          costo: fila.costo,
          moneda: fila.moneda,
          tEstimado: fila.tEstimado
        })) || []
    }

    try {
      await listaEnviosService.insertarLista(nuevaLista)

      const { data: listasActualizadas } =
        await listaEnviosService.buscarListaPorVendedor(modalValues.idVendedor)

      setEnviosUsuario(listasActualizadas)
      setActualizar((prev) => !prev)

      const listaCreada = listasActualizadas.find(
        (l) =>
          l.nombreLista.trim().toLowerCase() ===
          nuevaLista.nombreLista.trim().toLowerCase()
      )

      if (listaCreada) {
        setMedioEnvio({
          idLista: String(listaCreada.idLista),
          nombreLista: listaCreada.nombreLista
        })
      }

      dispatch(setModal({ show: false }))
      dispatch(resetModal())
      toast.success('Lista creada correctamente')
    } catch {
      toast.error('Ocurrió un error al agregar la lista.')
    }
  }

  const handleConfirmModal = async () => {
    const errores = {}
    const { nombreLista, vigenciaDesde, vigenciaHasta, grilla } = modalValues

    if (!nombreLista || nombreLista.trim() === '') {
      errores.nombreLista = 'El nombre es obligatorio.'
    }

    if (!vigenciaDesde) {
      errores.vigenciaDesde = 'Debe seleccionar una fecha de comienzo de vigencia.'
    } else {
      const fechaDesdeStr = vigenciaDesde
      const fechaActualStr = new Date().toISOString().split('T')[0]

      if (fechaDesdeStr < fechaActualStr) {
        errores.vigenciaDesde =
          'La fecha de inicio debe ser igual o posterior a la fecha actual.'
      }
    }

    if (!vigenciaHasta) {
      errores.vigenciaHasta = 'La fecha de fin de vigencia es obligatoria.'
    } else if (vigenciaHasta <= vigenciaDesde) {
      errores.vigenciaHasta =
        'La fecha de fin de vigencia debe ser mayor que la de comienzo.'
    }

    grilla.forEach((fila, i) => {
      const { cantidadDesde, cantidadHasta, costo, moneda, tEstimado, zona } = fila

      if (!zona || zona.trim() === '') {
        errores[`zona_${i}`] = 'La zona es obligatoria.'
      }

      if (cantidadDesde < 0 || !cantidadDesde) {
        errores[`cantidadDesde_${i}`] = 'Debe ingresar una cantidad mínima.'
      }

      if (i > 0) {
        const zonaActual = fila.zona?.trim().toUpperCase()
        const desdeActual = Number(cantidadDesde)

        const filasMismaZona = grilla
          .filter((f, idx) => idx < i && f.zona?.trim().toUpperCase() === zonaActual)
          .sort((a, b) => Number(a.cantidadDesde) - Number(b.cantidadDesde))

        if (filasMismaZona.length > 0) {
          const filaAnterior = filasMismaZona[filasMismaZona.length - 1]
          const hastaAnterior = Number(filaAnterior.cantidadHasta)

          if (desdeActual !== hastaAnterior + 1) {
            errores[`cantidadDesde_${i}`] = `En la zona "${
              fila.zona
            }", la cantidad desde debe ser ${
              hastaAnterior + 1
            } para evitar brechas o superposiciones.`
          }
        }
      }

      const desde = Number(cantidadDesde)
      const hasta = Number(cantidadHasta)

      if (!hasta || hasta <= desde) {
        errores[`cantidadHasta_${i}`] = 'La cantidad máxima debe ser mayor que la mínima.'
      }

      if (costo <= 0 || !costo) {
        errores[`costo_${i}`] = 'Debe ingresar el valor del costo.'
      }

      if (!moneda) {
        errores[`moneda_${i}`] = 'Debe seleccionar una moneda.'
      }

      if (tEstimado <= 0 || !tEstimado) {
        errores[`tEstimado_${i}`] = 'Debe ingresar el tiempo estimado.'
      }
    })

    if (
      enviosUsuario.some(
        (l) => l.nombreLista.trim().toLowerCase() === nombreLista.trim().toLowerCase()
      )
    ) {
      errores.nombreLista = 'Ya existe una lista con este nombre.'
    }

    dispatch(setModal({ errores, type: 'form' }))

    if (Object.keys(errores).length > 0) {
      return false
    }

    try {
      await handleConfirmarAgregado()
      dispatch(resetModal())

      return true
    } catch {
      toast.error('Ocurrió un error inesperado.')
      return false
    }
  }

  const eliminarFila = (index) => {
    dispatch(eliminarFilaGrid(index))
  }

  const copiarCampo = (name, value) => {
    dispatch(copiarCampoGrid({ name, value }))
  }

  return (
    <>
      {!vieneDeAdministrar && (
        <p className="descripcion-cuadro-publicacion">
          Incluya aquí las condiciones de pago, garantías y medios y costos de envío.
        </p>
      )}
      <div className="row">
        <div className="col-12 col-lg-6">
          <div className="row">
            <div className="col-4">Condiciones de Pago</div>
            <div className="col">
              {mediosPagos.map((medioPago) => (
                <div key={medioPago.idMedioPago} className="row">
                  <div className="col-1">
                    <Checkbox
                      name="mediosPagos"
                      checked={
                        values.mediosPagos
                          ? values.mediosPagos.some(
                              (m) => m.idMedioPago === medioPago.idMedioPago
                            )
                          : false
                      }
                      onChange={(e) => onHandleCheckbox(e, medioPago.idMedioPago)}
                    />
                  </div>
                  <div className="col">
                    <i className={medioPago.icono} aria-hidden="true" />
                    {medioPago.nombre}
                  </div>
                </div>
              ))}
              {errorMediosPagos && (
                <div className="text-danger mt-1">
                  Debes seleccionar por lo menos 1 medio de pago
                </div>
              )}
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-2">Garantía</div>
            <div className="col">
              {garantias.map((garantia) => (
                <div key={garantia.idGarantia} className="row">
                  <div className="col-1">
                    <Checkbox
                      name="garantias"
                      checked={
                        values.garantias
                          ? values.garantias.some(
                              (g) => g.idGarantia === garantia.idGarantia
                            )
                          : false
                      }
                      onChange={(e) => onHandleCheckbox(e, garantia.idGarantia)}
                    />
                  </div>
                  <div className="col">
                    <i className={garantia.icono} aria-hidden="true" />
                    {garantia.nombre}
                  </div>
                </div>
              ))}
              <div className="row">
                <div className="col-1">
                  <Checkbox name="extensionGarantia" value={values} onChange={onChange} />
                </div>
                <div className="col">
                  <i className="fa fa-file-text-o fa-fw" aria-hidden="true" />
                  Extensión de Garantía
                  <br />
                  <br />
                  {values.extensionGarantia && (
                    <div className="row">
                      <div className="col">
                        <div className="row">
                          <div className="col-12">Tiempo de Extensión</div>
                          <div className="col-12">
                            <NumericFormat
                              name="garantiaPlazo"
                              onChange={(e) => handleChange(e)}
                              className="input-text"
                              thousandSeparator={false}
                              decimalScale={0}
                            />{' '}
                            Meses
                          </div>
                        </div>
                      </div>
                      <div className="col">
                        <div className="row">
                          <div className="col-12">Monto por la extensión</div>
                          <div className="col-12">
                            <NumericFormat
                              name="garantiaMonto"
                              onChange={(e) => handleChange(e)}
                              className="input-text"
                              thousandSeparator={false}
                              decimalScale={2}
                              placeholder="$0.00"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-6">
          <div className="row">
            <div className="col">Medios de Envío</div>
            <div className="col">
              {mediosEnvios.map((envio) => (
                <div key={envio.idMedioEnvio} className="row">
                  <div className="col-1">
                    <Checkbox
                      name="mediosEnvios"
                      checked={
                        mediosEnviosSeleccionados
                          ? mediosEnviosSeleccionados.some(
                              (m) => m.idMedioEnvio === envio.idMedioEnvio
                            )
                          : false
                      }
                      onChange={(e) =>
                        onHandleCheckboxMediosEnvios(e, envio.idMedioEnvio)
                      }
                    />
                  </div>
                  <div className="col">
                    <i className={envio.icono} aria-hidden="true" />
                    {envio.nombre}
                  </div>
                  {envio.idMedioEnvio === ENVIO_A_CARGO_COMPRADOR &&
                    mediosEnviosSeleccionados.some(
                      (m) => m.idMedioEnvio === envio.idMedioEnvio
                    ) && (
                      <div className="row mt-2">
                        <div className="col d-flex align-items-center">
                          <div
                            className="text-primary fw-bold mr-2"
                            style={{ cursor: 'pointer' }}
                            onClick={abrirModalLista}
                            title="Agregar nueva lista de envio"
                          >
                            +
                          </div>
                          <GenericSelect
                            options={enviosUsuario.map((envio) => ({
                              key: envio.idLista,
                              value: String(envio.idLista),
                              label: envio.nombreLista
                            }))}
                            className="select-medio-envio"
                            value={String(medioEnvio.idLista || '')}
                            onChange={(nuevoValor) => {
                              handleSeleccionListaEnvio('idLista', nuevoValor)
                              onChange(
                                {
                                  currentTarget: {
                                    name: 'idListaEnvio',
                                    value: nuevoValor
                                  }
                                },
                                'num'
                              )
                            }}
                            error={errores.idListaEnvio}
                            placeholder="Seleccione una lista"
                            id="listaEnvio"
                          />
                        </div>
                      </div>
                    )}
                </div>
              ))}
              {errorMediosEnvios && (
                <div className="text-danger mt-1">
                  Debes seleccionar por lo menos 1 medio de envio
                </div>
              )}
            </div>
          </div>
          <br />
          <GenericModal
            onConfirm={handleConfirmModal}
            onChange={handleChangeModal}
            onAddItem={agregarFila}
            onRemoveItem={eliminarFila}
            onCopyField={copiarCampo}
          />
        </div>
      </div>
    </>
  )
}

VentasEspeciales.propTypes = {
  values: PropTypes.shape({
    mediosPagos: PropTypes.arrayOf(PropTypes.object),
    garantias: PropTypes.arrayOf(PropTypes.object),
    mediosEnvios: PropTypes.arrayOf(PropTypes.object),
    extensionGarantia: PropTypes.bool,
    idListaEnvio: PropTypes.number,
    nombreListaEnvio: PropTypes.string
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onAddGarantia: PropTypes.func.isRequired,
  vieneDeAdministrar: PropTypes.bool,
  errorMediosEnvios: PropTypes.bool,
  errorMediosPagos: PropTypes.bool,
  idPublicacion: PropTypes.number
}

export default VentasEspeciales
